import * as $runtime from "../runtime.js";
import * as App$dCondition from "../App.Condition/index.js";
import * as App$dDeck from "../App.Deck/index.js";
import * as App$dResult from "../App.Result/index.js";
import * as Codec$dJSON$dDecodeError from "../Codec.JSON.DecodeError/index.js";
import * as Control$dMonad$dExcept$dTrans from "../Control.Monad.Except.Trans/index.js";
import * as Control$dMonad$dFree from "../Control.Monad.Free/index.js";
import * as Data$dArray from "../Data.Array/index.js";
import * as Data$dCatList from "../Data.CatList/index.js";
import * as Data$dCatQueue from "../Data.CatQueue/index.js";
import * as Data$dEither from "../Data.Either/index.js";
import * as Data$dEq from "../Data.Eq/index.js";
import * as Data$dFoldable from "../Data.Foldable/index.js";
import * as Data$dFunctor from "../Data.Functor/index.js";
import * as Data$dList$dTypes from "../Data.List.Types/index.js";
import * as Data$dMap$dInternal from "../Data.Map.Internal/index.js";
import * as Data$dMaybe from "../Data.Maybe/index.js";
import * as Data$dMonoid from "../Data.Monoid/index.js";
import * as Data$dOrd from "../Data.Ord/index.js";
import * as Data$dString$dCodeUnits from "../Data.String.CodeUnits/index.js";
import * as Data$dTuple from "../Data.Tuple/index.js";
import * as Data$dUUID from "../Data.UUID/index.js";
import * as Effect from "../Effect/index.js";
import * as Effect$dAff from "../Effect.Aff/index.js";
import * as Effect$dConsole from "../Effect.Console/index.js";
import * as Foreign from "../Foreign/index.js";
import * as Halogen$dComponent from "../Halogen.Component/index.js";
import * as Halogen$dHTML from "../Halogen.HTML/index.js";
import * as Halogen$dHTML$dProperties from "../Halogen.HTML.Properties/index.js";
import * as Halogen$dQuery from "../Halogen.Query/index.js";
import * as Halogen$dQuery$dHalogenM from "../Halogen.Query.HalogenM/index.js";
import * as Halogen$dSubscription from "../Halogen.Subscription/index.js";
import * as Halogen$dVDom$dTypes from "../Halogen.VDom.Types/index.js";
import * as $$JSON from "../JSON/index.js";
import * as JSON$dInternal from "../JSON.Internal/index.js";
import * as JSON$dPath from "../JSON.Path/index.js";
import * as JSURI from "../JSURI/index.js";
import * as Routing$dPushState from "../Routing.PushState/index.js";
import * as TcgCalculator$dCodec from "../TcgCalculator.Codec/index.js";
import * as TcgCalculator$dTypes from "../TcgCalculator.Types/index.js";
import * as Type$dProxy from "../Type.Proxy/index.js";
import * as Util$dArray from "../Util.Array/index.js";
import * as Util$dHalogen from "../Util.Halogen/index.js";
const $Action = (tag, _1, _2) => ({tag, _1, _2});
const resultIsSymbol = {reflectSymbol: () => "result"};
const slot1 = /* #__PURE__ */ Halogen$dHTML.slot()({reflectSymbol: () => "deck"})(Data$dOrd.ordUnit);
const conditionIsSymbol = {reflectSymbol: () => "condition"};
const slot2 = /* #__PURE__ */ Halogen$dHTML.slot()(conditionIsSymbol)(Data$dUUID.ordUUID);
const mempty = v => () => {};
const monadEffectHalogenM = /* #__PURE__ */ Halogen$dQuery$dHalogenM.monadEffectHalogenM(Effect$dAff.monadEffectAff);
const generateId = /* #__PURE__ */ (() => monadEffectHalogenM.liftEffect(Data$dUUID.getUUIDImpl))();
const tell1 = /* #__PURE__ */ Halogen$dQuery.tell()(conditionIsSymbol)(Data$dUUID.ordUUID);
const foldMap = /* #__PURE__ */ (() => {
  const mempty$1 = Control$dMonad$dFree.monoidFree(Data$dMonoid.monoidUnit).mempty;
  return v => v1 => {
    if (v1.tag === "Nothing") { return mempty$1; }
    if (v1.tag === "Just") { return v(v1._1); }
    $runtime.fail();
  };
})();
const $$get = /* #__PURE__ */ Control$dMonad$dFree.$Free(
  /* #__PURE__ */ Control$dMonad$dFree.$FreeView(
    "Bind",
    /* #__PURE__ */ Halogen$dQuery$dHalogenM.$HalogenF("State", s => Data$dTuple.$Tuple(s, s)),
    x => Control$dMonad$dFree.$Free(Control$dMonad$dFree.$FreeView("Return", x), Data$dCatList.CatNil)
  ),
  Data$dCatList.CatNil
);
const for_ = /* #__PURE__ */ Data$dFoldable.for_(Control$dMonad$dFree.freeApplicative)(Data$dFoldable.foldableArray);
const tell2 = /* #__PURE__ */ Halogen$dQuery.tell()(resultIsSymbol)(Data$dOrd.ordUnit);
const requestAll = /* #__PURE__ */ Halogen$dQuery.requestAll()(conditionIsSymbol)(Data$dUUID.ordUUID);
const lookup = k => {
  const go = go$a0$copy => {
    let go$a0 = go$a0$copy, go$c = true, go$r;
    while (go$c) {
      const v = go$a0;
      if (v.tag === "Leaf") {
        go$c = false;
        go$r = Data$dMaybe.Nothing;
        continue;
      }
      if (v.tag === "Node") {
        const v1 = Data$dOrd.ordString.compare(k)(v._3);
        if (v1 === "LT") {
          go$a0 = v._5;
          continue;
        }
        if (v1 === "GT") {
          go$a0 = v._6;
          continue;
        }
        if (v1 === "EQ") {
          go$c = false;
          go$r = Data$dMaybe.$Maybe("Just", v._4);
          continue;
        }
      }
      $runtime.fail();
    }
    return go$r;
  };
  return go;
};
const Initialize = /* #__PURE__ */ $Action("Initialize");
const PrepareDefaultState = /* #__PURE__ */ $Action("PrepareDefaultState");
const UpdateDeck = value0 => $Action("UpdateDeck", value0);
const AddCondition = /* #__PURE__ */ $Action("AddCondition");
const RemoveCondition = value0 => $Action("RemoveCondition", value0);
const ToggleDisabled = value0 => $Action("ToggleDisabled", value0);
const SwapPrev = value0 => $Action("SwapPrev", value0);
const SwapNext = value0 => $Action("SwapNext", value0);
const ReceiveConditionUpdated = value0 => value1 => $Action("ReceiveConditionUpdated", value0, value1);
const RestoreState = value0 => $Action("RestoreState", value0);
const ApplyState = value0 => value1 => $Action("ApplyState", value0, value1);
const SaveState = /* #__PURE__ */ $Action("SaveState");
const component = /* #__PURE__ */ (() => {
  const action$lazy = $runtime.binding(() => {
    const $0 = Control$dMonad$dExcept$dTrans.bindExceptT(Effect.monadEffect);
    return v => {
      if (v.tag === "Initialize") {
        const $1 = monadEffectHalogenM.liftEffect(Halogen$dSubscription.create);
        const $2 = v1 => {
          const $2 = v1.emitter;
          return Control$dMonad$dFree.$Free(
            Control$dMonad$dFree.$FreeView(
              "Bind",
              Halogen$dQuery$dHalogenM.$HalogenF("Subscribe", v$1 => $2, Halogen$dQuery$dHalogenM.identity),
              x => Control$dMonad$dFree.$Free(Control$dMonad$dFree.$FreeView("Return", x), Data$dCatList.CatNil)
            ),
            Data$dCatList.$CatList(
              "CatCons",
              () => {
                const $3 = monadEffectHalogenM.liftEffect(Routing$dPushState.makeInterface);
                const $4 = psi => Control$dMonad$dFree.$Free(
                  Control$dMonad$dFree.$FreeView(
                    "Bind",
                    Halogen$dQuery$dHalogenM.$HalogenF(
                      "State",
                      s => Data$dTuple.$Tuple(
                        undefined,
                        {
                          ...s,
                          pushState: $$export => psi.pushState(TcgCalculator$dCodec.appState._2($$export)._1)("#" + $$JSON.print(TcgCalculator$dCodec.hashAppState._2($$export)._1)),
                          replaceState: $$export => psi.replaceState(TcgCalculator$dCodec.appState._2($$export)._1)("#" + $$JSON.print(TcgCalculator$dCodec.hashAppState._2($$export)._1))
                        }
                      )
                    ),
                    x => Control$dMonad$dFree.$Free(Control$dMonad$dFree.$FreeView("Return", x), Data$dCatList.CatNil)
                  ),
                  Data$dCatList.$CatList(
                    "CatCons",
                    () => {
                      const $4 = monadEffectHalogenM.liftEffect(psi.listen(x => v1.listener((() => {
                        if (!Foreign.isNull(x.state)) { return $Action("ApplyState", x.state, x.hash); }
                        if (x.hash !== "") { return $Action("RestoreState", x.hash); }
                        return PrepareDefaultState;
                      })())));
                      const $5 = () => {
                        const $5 = x => action$lazy()((() => {
                          if (!Foreign.isNull(x.state)) { return $Action("ApplyState", x.state, x.hash); }
                          if (x.hash !== "") { return $Action("RestoreState", x.hash); }
                          return PrepareDefaultState;
                        })());
                        const $6 = monadEffectHalogenM.liftEffect(psi.locationState);
                        return Control$dMonad$dFree.$Free(
                          $6._1,
                          (() => {
                            if ($6._2.tag === "CatNil") { return Data$dCatList.$CatList("CatCons", $5, Data$dCatQueue.$CatQueue(Data$dList$dTypes.Nil, Data$dList$dTypes.Nil)); }
                            if ($6._2.tag === "CatCons") {
                              return Data$dCatList.$CatList(
                                "CatCons",
                                $6._2._1,
                                Data$dCatQueue.$CatQueue(
                                  $6._2._2._1,
                                  Data$dList$dTypes.$List(
                                    "Cons",
                                    Data$dCatList.$CatList("CatCons", $5, Data$dCatQueue.$CatQueue(Data$dList$dTypes.Nil, Data$dList$dTypes.Nil)),
                                    $6._2._2._2
                                  )
                                )
                              );
                            }
                            $runtime.fail();
                          })()
                        );
                      };
                      return Control$dMonad$dFree.$Free(
                        $4._1,
                        (() => {
                          if ($4._2.tag === "CatNil") { return Data$dCatList.$CatList("CatCons", $5, Data$dCatQueue.$CatQueue(Data$dList$dTypes.Nil, Data$dList$dTypes.Nil)); }
                          if ($4._2.tag === "CatCons") {
                            return Data$dCatList.$CatList(
                              "CatCons",
                              $4._2._1,
                              Data$dCatQueue.$CatQueue(
                                $4._2._2._1,
                                Data$dList$dTypes.$List(
                                  "Cons",
                                  Data$dCatList.$CatList("CatCons", $5, Data$dCatQueue.$CatQueue(Data$dList$dTypes.Nil, Data$dList$dTypes.Nil)),
                                  $4._2._2._2
                                )
                              )
                            );
                          }
                          $runtime.fail();
                        })()
                      );
                    },
                    Data$dCatQueue.$CatQueue(Data$dList$dTypes.Nil, Data$dList$dTypes.Nil)
                  )
                );
                return Control$dMonad$dFree.$Free(
                  $3._1,
                  (() => {
                    if ($3._2.tag === "CatNil") { return Data$dCatList.$CatList("CatCons", $4, Data$dCatQueue.$CatQueue(Data$dList$dTypes.Nil, Data$dList$dTypes.Nil)); }
                    if ($3._2.tag === "CatCons") {
                      return Data$dCatList.$CatList(
                        "CatCons",
                        $3._2._1,
                        Data$dCatQueue.$CatQueue(
                          $3._2._2._1,
                          Data$dList$dTypes.$List(
                            "Cons",
                            Data$dCatList.$CatList("CatCons", $4, Data$dCatQueue.$CatQueue(Data$dList$dTypes.Nil, Data$dList$dTypes.Nil)),
                            $3._2._2._2
                          )
                        )
                      );
                    }
                    $runtime.fail();
                  })()
                );
              },
              Data$dCatQueue.$CatQueue(Data$dList$dTypes.Nil, Data$dList$dTypes.Nil)
            )
          );
        };
        return Control$dMonad$dFree.$Free(
          $1._1,
          (() => {
            if ($1._2.tag === "CatNil") { return Data$dCatList.$CatList("CatCons", $2, Data$dCatQueue.$CatQueue(Data$dList$dTypes.Nil, Data$dList$dTypes.Nil)); }
            if ($1._2.tag === "CatCons") {
              return Data$dCatList.$CatList(
                "CatCons",
                $1._2._1,
                Data$dCatQueue.$CatQueue(
                  $1._2._2._1,
                  Data$dList$dTypes.$List("Cons", Data$dCatList.$CatList("CatCons", $2, Data$dCatQueue.$CatQueue(Data$dList$dTypes.Nil, Data$dList$dTypes.Nil)), $1._2._2._2)
                )
              );
            }
            $runtime.fail();
          })()
        );
      }
      if (v.tag === "PrepareDefaultState") {
        return Control$dMonad$dFree.$Free(
          generateId._1,
          (() => {
            if (generateId._2.tag === "CatNil") {
              return Data$dCatList.$CatList(
                "CatCons",
                cardId => {
                  const $1 = conditionId => {
                    const $1 = groupId => Control$dMonad$dFree.$Free(
                      Control$dMonad$dFree.$FreeView(
                        "Bind",
                        Halogen$dQuery$dHalogenM.$HalogenF("State", s => Data$dTuple.$Tuple(s.replaceState, s)),
                        x => Control$dMonad$dFree.$Free(Control$dMonad$dFree.$FreeView("Return", x), Data$dCatList.CatNil)
                      ),
                      Data$dCatList.$CatList(
                        "CatCons",
                        replaceState => monadEffectHalogenM.liftEffect(replaceState({
                          deck: {cards: [{id: cardId, name: "Card1", count: 3}], others: 37, hand: 5},
                          condition: [
                            {
                              id: groupId,
                              conditions: [
                                {
                                  id: conditionId,
                                  condition: {
                                    mode: TcgCalculator$dTypes.AtLeast,
                                    count: 1,
                                    cards: Data$dMap$dInternal.$$$Map("Node", 1, 1, cardId, undefined, Data$dMap$dInternal.Leaf, Data$dMap$dInternal.Leaf)
                                  },
                                  disabled: false
                                }
                              ],
                              disabled: false
                            }
                          ]
                        })),
                        Data$dCatQueue.$CatQueue(Data$dList$dTypes.Nil, Data$dList$dTypes.Nil)
                      )
                    );
                    return Control$dMonad$dFree.$Free(
                      generateId._1,
                      (() => {
                        if (generateId._2.tag === "CatNil") {
                          return Data$dCatList.$CatList("CatCons", $1, Data$dCatQueue.$CatQueue(Data$dList$dTypes.Nil, Data$dList$dTypes.Nil));
                        }
                        if (generateId._2.tag === "CatCons") {
                          return Data$dCatList.$CatList(
                            "CatCons",
                            generateId._2._1,
                            Data$dCatQueue.$CatQueue(
                              generateId._2._2._1,
                              Data$dList$dTypes.$List(
                                "Cons",
                                Data$dCatList.$CatList("CatCons", $1, Data$dCatQueue.$CatQueue(Data$dList$dTypes.Nil, Data$dList$dTypes.Nil)),
                                generateId._2._2._2
                              )
                            )
                          );
                        }
                        $runtime.fail();
                      })()
                    );
                  };
                  return Control$dMonad$dFree.$Free(
                    generateId._1,
                    (() => {
                      if (generateId._2.tag === "CatNil") { return Data$dCatList.$CatList("CatCons", $1, Data$dCatQueue.$CatQueue(Data$dList$dTypes.Nil, Data$dList$dTypes.Nil)); }
                      if (generateId._2.tag === "CatCons") {
                        return Data$dCatList.$CatList(
                          "CatCons",
                          generateId._2._1,
                          Data$dCatQueue.$CatQueue(
                            generateId._2._2._1,
                            Data$dList$dTypes.$List(
                              "Cons",
                              Data$dCatList.$CatList("CatCons", $1, Data$dCatQueue.$CatQueue(Data$dList$dTypes.Nil, Data$dList$dTypes.Nil)),
                              generateId._2._2._2
                            )
                          )
                        );
                      }
                      $runtime.fail();
                    })()
                  );
                },
                Data$dCatQueue.$CatQueue(Data$dList$dTypes.Nil, Data$dList$dTypes.Nil)
              );
            }
            if (generateId._2.tag === "CatCons") {
              return Data$dCatList.$CatList(
                "CatCons",
                generateId._2._1,
                Data$dCatQueue.$CatQueue(
                  generateId._2._2._1,
                  Data$dList$dTypes.$List(
                    "Cons",
                    Data$dCatList.$CatList(
                      "CatCons",
                      cardId => {
                        const $1 = conditionId => {
                          const $1 = groupId => Control$dMonad$dFree.$Free(
                            Control$dMonad$dFree.$FreeView(
                              "Bind",
                              Halogen$dQuery$dHalogenM.$HalogenF("State", s => Data$dTuple.$Tuple(s.replaceState, s)),
                              x => Control$dMonad$dFree.$Free(Control$dMonad$dFree.$FreeView("Return", x), Data$dCatList.CatNil)
                            ),
                            Data$dCatList.$CatList(
                              "CatCons",
                              replaceState => monadEffectHalogenM.liftEffect(replaceState({
                                deck: {cards: [{id: cardId, name: "Card1", count: 3}], others: 37, hand: 5},
                                condition: [
                                  {
                                    id: groupId,
                                    conditions: [
                                      {
                                        id: conditionId,
                                        condition: {
                                          mode: TcgCalculator$dTypes.AtLeast,
                                          count: 1,
                                          cards: Data$dMap$dInternal.$$$Map("Node", 1, 1, cardId, undefined, Data$dMap$dInternal.Leaf, Data$dMap$dInternal.Leaf)
                                        },
                                        disabled: false
                                      }
                                    ],
                                    disabled: false
                                  }
                                ]
                              })),
                              Data$dCatQueue.$CatQueue(Data$dList$dTypes.Nil, Data$dList$dTypes.Nil)
                            )
                          );
                          return Control$dMonad$dFree.$Free(
                            generateId._1,
                            (() => {
                              if (generateId._2.tag === "CatNil") {
                                return Data$dCatList.$CatList("CatCons", $1, Data$dCatQueue.$CatQueue(Data$dList$dTypes.Nil, Data$dList$dTypes.Nil));
                              }
                              if (generateId._2.tag === "CatCons") {
                                return Data$dCatList.$CatList(
                                  "CatCons",
                                  generateId._2._1,
                                  Data$dCatQueue.$CatQueue(
                                    generateId._2._2._1,
                                    Data$dList$dTypes.$List(
                                      "Cons",
                                      Data$dCatList.$CatList("CatCons", $1, Data$dCatQueue.$CatQueue(Data$dList$dTypes.Nil, Data$dList$dTypes.Nil)),
                                      generateId._2._2._2
                                    )
                                  )
                                );
                              }
                              $runtime.fail();
                            })()
                          );
                        };
                        return Control$dMonad$dFree.$Free(
                          generateId._1,
                          (() => {
                            if (generateId._2.tag === "CatNil") {
                              return Data$dCatList.$CatList("CatCons", $1, Data$dCatQueue.$CatQueue(Data$dList$dTypes.Nil, Data$dList$dTypes.Nil));
                            }
                            if (generateId._2.tag === "CatCons") {
                              return Data$dCatList.$CatList(
                                "CatCons",
                                generateId._2._1,
                                Data$dCatQueue.$CatQueue(
                                  generateId._2._2._1,
                                  Data$dList$dTypes.$List(
                                    "Cons",
                                    Data$dCatList.$CatList("CatCons", $1, Data$dCatQueue.$CatQueue(Data$dList$dTypes.Nil, Data$dList$dTypes.Nil)),
                                    generateId._2._2._2
                                  )
                                )
                              );
                            }
                            $runtime.fail();
                          })()
                        );
                      },
                      Data$dCatQueue.$CatQueue(Data$dList$dTypes.Nil, Data$dList$dTypes.Nil)
                    ),
                    generateId._2._2._2
                  )
                )
              );
            }
            $runtime.fail();
          })()
        );
      }
      if (v.tag === "UpdateDeck") {
        const $1 = v._1;
        return Control$dMonad$dFree.$Free(
          Control$dMonad$dFree.$FreeView(
            "Bind",
            Halogen$dQuery$dHalogenM.$HalogenF("State", s => Data$dTuple.$Tuple(undefined, {...s, deck: $1})),
            x => Control$dMonad$dFree.$Free(Control$dMonad$dFree.$FreeView("Return", x), Data$dCatList.CatNil)
          ),
          Data$dCatList.$CatList("CatCons", () => action$lazy()(SaveState), Data$dCatQueue.$CatQueue(Data$dList$dTypes.Nil, Data$dList$dTypes.Nil))
        );
      }
      if (v.tag === "AddCondition") {
        const $1 = id => Control$dMonad$dFree.$Free(
          Control$dMonad$dFree.$FreeView(
            "Bind",
            Halogen$dQuery$dHalogenM.$HalogenF("State", s => Data$dTuple.$Tuple(undefined, {...s, conditions: Data$dArray.snoc(s.conditions)(id)})),
            x => Control$dMonad$dFree.$Free(Control$dMonad$dFree.$FreeView("Return", x), Data$dCatList.CatNil)
          ),
          Data$dCatList.$CatList("CatCons", () => action$lazy()(SaveState), Data$dCatQueue.$CatQueue(Data$dList$dTypes.Nil, Data$dList$dTypes.Nil))
        );
        return Control$dMonad$dFree.$Free(
          generateId._1,
          (() => {
            if (generateId._2.tag === "CatNil") { return Data$dCatList.$CatList("CatCons", $1, Data$dCatQueue.$CatQueue(Data$dList$dTypes.Nil, Data$dList$dTypes.Nil)); }
            if (generateId._2.tag === "CatCons") {
              return Data$dCatList.$CatList(
                "CatCons",
                generateId._2._1,
                Data$dCatQueue.$CatQueue(
                  generateId._2._2._1,
                  Data$dList$dTypes.$List(
                    "Cons",
                    Data$dCatList.$CatList("CatCons", $1, Data$dCatQueue.$CatQueue(Data$dList$dTypes.Nil, Data$dList$dTypes.Nil)),
                    generateId._2._2._2
                  )
                )
              );
            }
            $runtime.fail();
          })()
        );
      }
      if (v.tag === "RemoveCondition") {
        const $1 = v._1;
        return Control$dMonad$dFree.$Free(
          Control$dMonad$dFree.$FreeView(
            "Bind",
            Halogen$dQuery$dHalogenM.$HalogenF("State", s => Data$dTuple.$Tuple(undefined, {...s, conditions: Data$dArray.deleteBy(Data$dUUID.eqUUID.eq)($1)(s.conditions)})),
            x => Control$dMonad$dFree.$Free(Control$dMonad$dFree.$FreeView("Return", x), Data$dCatList.CatNil)
          ),
          Data$dCatList.$CatList("CatCons", () => action$lazy()(SaveState), Data$dCatQueue.$CatQueue(Data$dList$dTypes.Nil, Data$dList$dTypes.Nil))
        );
      }
      if (v.tag === "ToggleDisabled") {
        const $1 = tell1(Type$dProxy.Proxy)(v._1)(App$dCondition.ToggleDisabled);
        return Control$dMonad$dFree.$Free(
          $1._1,
          (() => {
            if ($1._2.tag === "CatNil") {
              return Data$dCatList.$CatList("CatCons", () => action$lazy()(SaveState), Data$dCatQueue.$CatQueue(Data$dList$dTypes.Nil, Data$dList$dTypes.Nil));
            }
            if ($1._2.tag === "CatCons") {
              return Data$dCatList.$CatList(
                "CatCons",
                $1._2._1,
                Data$dCatQueue.$CatQueue(
                  $1._2._2._1,
                  Data$dList$dTypes.$List(
                    "Cons",
                    Data$dCatList.$CatList("CatCons", () => action$lazy()(SaveState), Data$dCatQueue.$CatQueue(Data$dList$dTypes.Nil, Data$dList$dTypes.Nil)),
                    $1._2._2._2
                  )
                )
              );
            }
            $runtime.fail();
          })()
        );
      }
      if (v.tag === "SwapPrev") {
        const $1 = v._1;
        return Control$dMonad$dFree.$Free(
          Control$dMonad$dFree.$FreeView(
            "Bind",
            Halogen$dQuery$dHalogenM.$HalogenF("State", s => Data$dTuple.$Tuple(s.conditions, s)),
            x => Control$dMonad$dFree.$Free(Control$dMonad$dFree.$FreeView("Return", x), Data$dCatList.CatNil)
          ),
          Data$dCatList.$CatList(
            "CatCons",
            conditions => {
              const $2 = foldMap(x => {
                const $2 = x - 1 | 0;
                const $3 = Util$dArray.swap($2)($2 + 1 | 0);
                return Control$dMonad$dFree.$Free(
                  Control$dMonad$dFree.$FreeView(
                    "Bind",
                    Halogen$dQuery$dHalogenM.$HalogenF("State", s => Data$dTuple.$Tuple(undefined, {...s, conditions: $3(s.conditions)})),
                    x$1 => Control$dMonad$dFree.$Free(Control$dMonad$dFree.$FreeView("Return", x$1), Data$dCatList.CatNil)
                  ),
                  Data$dCatList.CatNil
                );
              })(Data$dArray.findIndexImpl(Data$dMaybe.Just, Data$dMaybe.Nothing, v1 => v1 === $1, conditions));
              return Control$dMonad$dFree.$Free(
                $2._1,
                (() => {
                  if ($2._2.tag === "CatNil") {
                    return Data$dCatList.$CatList("CatCons", () => action$lazy()(SaveState), Data$dCatQueue.$CatQueue(Data$dList$dTypes.Nil, Data$dList$dTypes.Nil));
                  }
                  if ($2._2.tag === "CatCons") {
                    return Data$dCatList.$CatList(
                      "CatCons",
                      $2._2._1,
                      Data$dCatQueue.$CatQueue(
                        $2._2._2._1,
                        Data$dList$dTypes.$List(
                          "Cons",
                          Data$dCatList.$CatList("CatCons", () => action$lazy()(SaveState), Data$dCatQueue.$CatQueue(Data$dList$dTypes.Nil, Data$dList$dTypes.Nil)),
                          $2._2._2._2
                        )
                      )
                    );
                  }
                  $runtime.fail();
                })()
              );
            },
            Data$dCatQueue.$CatQueue(Data$dList$dTypes.Nil, Data$dList$dTypes.Nil)
          )
        );
      }
      if (v.tag === "SwapNext") {
        const $1 = v._1;
        return Control$dMonad$dFree.$Free(
          Control$dMonad$dFree.$FreeView(
            "Bind",
            Halogen$dQuery$dHalogenM.$HalogenF("State", s => Data$dTuple.$Tuple(s.conditions, s)),
            x => Control$dMonad$dFree.$Free(Control$dMonad$dFree.$FreeView("Return", x), Data$dCatList.CatNil)
          ),
          Data$dCatList.$CatList(
            "CatCons",
            conditions => {
              const $2 = foldMap(x => {
                const $2 = Util$dArray.swap(x)(x + 1 | 0);
                return Control$dMonad$dFree.$Free(
                  Control$dMonad$dFree.$FreeView(
                    "Bind",
                    Halogen$dQuery$dHalogenM.$HalogenF("State", s => Data$dTuple.$Tuple(undefined, {...s, conditions: $2(s.conditions)})),
                    x$1 => Control$dMonad$dFree.$Free(Control$dMonad$dFree.$FreeView("Return", x$1), Data$dCatList.CatNil)
                  ),
                  Data$dCatList.CatNil
                );
              })(Data$dArray.findIndexImpl(Data$dMaybe.Just, Data$dMaybe.Nothing, v1 => v1 === $1, conditions));
              return Control$dMonad$dFree.$Free(
                $2._1,
                (() => {
                  if ($2._2.tag === "CatNil") {
                    return Data$dCatList.$CatList("CatCons", () => action$lazy()(SaveState), Data$dCatQueue.$CatQueue(Data$dList$dTypes.Nil, Data$dList$dTypes.Nil));
                  }
                  if ($2._2.tag === "CatCons") {
                    return Data$dCatList.$CatList(
                      "CatCons",
                      $2._2._1,
                      Data$dCatQueue.$CatQueue(
                        $2._2._2._1,
                        Data$dList$dTypes.$List(
                          "Cons",
                          Data$dCatList.$CatList("CatCons", () => action$lazy()(SaveState), Data$dCatQueue.$CatQueue(Data$dList$dTypes.Nil, Data$dList$dTypes.Nil)),
                          $2._2._2._2
                        )
                      )
                    );
                  }
                  $runtime.fail();
                })()
              );
            },
            Data$dCatQueue.$CatQueue(Data$dList$dTypes.Nil, Data$dList$dTypes.Nil)
          )
        );
      }
      if (v.tag === "ReceiveConditionUpdated") {
        if (v._2 === "Updated") { return action$lazy()(SaveState); }
        if (v._2 === "AllConditionDeleted") { return action$lazy()($Action("RemoveCondition", v._1)); }
        $runtime.fail();
      }
      if (v.tag === "RestoreState") {
        const $1 = Data$dString$dCodeUnits.stripPrefix("#")(v._1);
        const $2 = monadEffectHalogenM.liftEffect((() => {
          const $2 = (() => {
            if ($1.tag === "Just") { return JSURI._decodeURIComponent(v$1 => Data$dMaybe.Nothing, Data$dMaybe.Just, $1._1); }
            if ($1.tag === "Nothing") { return Data$dMaybe.Nothing; }
            $runtime.fail();
          })();
          return $0.bind((() => {
            const $3 = JSON$dInternal._parse(
              Data$dEither.Left,
              Data$dEither.Right,
              (() => {
                if ($2.tag === "Nothing") { return ""; }
                if ($2.tag === "Just") { return $2._1; }
                $runtime.fail();
              })()
            );
            const $4 = (() => {
              if ($3.tag === "Left") { return Data$dEither.$Either("Left", {path: JSON$dPath.Tip, message: $3._1, causes: []}); }
              if ($3.tag === "Right") { return Data$dEither.$Either("Right", $3._1); }
              $runtime.fail();
            })();
            return () => $4;
          })())(TcgCalculator$dCodec.hashAppState._1);
        })());
        const $3 = result => {
          if (result.tag === "Left") {
            const $3 = monadEffectHalogenM.liftEffect(Effect$dConsole.error("Failed to decode Hash JSON: " + Codec$dJSON$dDecodeError.print(result._1)));
            return Control$dMonad$dFree.$Free(
              $3._1,
              (() => {
                if ($3._2.tag === "CatNil") {
                  return Data$dCatList.$CatList("CatCons", () => action$lazy()(PrepareDefaultState), Data$dCatQueue.$CatQueue(Data$dList$dTypes.Nil, Data$dList$dTypes.Nil));
                }
                if ($3._2.tag === "CatCons") {
                  return Data$dCatList.$CatList(
                    "CatCons",
                    $3._2._1,
                    Data$dCatQueue.$CatQueue(
                      $3._2._2._1,
                      Data$dList$dTypes.$List(
                        "Cons",
                        Data$dCatList.$CatList("CatCons", () => action$lazy()(PrepareDefaultState), Data$dCatQueue.$CatQueue(Data$dList$dTypes.Nil, Data$dList$dTypes.Nil)),
                        $3._2._2._2
                      )
                    )
                  );
                }
                $runtime.fail();
              })()
            );
          }
          if (result.tag === "Right") {
            const $3 = result._1;
            return Control$dMonad$dFree.$Free(
              Control$dMonad$dFree.$FreeView(
                "Bind",
                Halogen$dQuery$dHalogenM.$HalogenF("State", s => Data$dTuple.$Tuple(s.replaceState, s)),
                x => Control$dMonad$dFree.$Free(Control$dMonad$dFree.$FreeView("Return", x), Data$dCatList.CatNil)
              ),
              Data$dCatList.$CatList(
                "CatCons",
                replaceState => monadEffectHalogenM.liftEffect(replaceState($3)),
                Data$dCatQueue.$CatQueue(Data$dList$dTypes.Nil, Data$dList$dTypes.Nil)
              )
            );
          }
          $runtime.fail();
        };
        return Control$dMonad$dFree.$Free(
          $2._1,
          (() => {
            if ($2._2.tag === "CatNil") { return Data$dCatList.$CatList("CatCons", $3, Data$dCatQueue.$CatQueue(Data$dList$dTypes.Nil, Data$dList$dTypes.Nil)); }
            if ($2._2.tag === "CatCons") {
              return Data$dCatList.$CatList(
                "CatCons",
                $2._2._1,
                Data$dCatQueue.$CatQueue(
                  $2._2._2._1,
                  Data$dList$dTypes.$List("Cons", Data$dCatList.$CatList("CatCons", $3, Data$dCatQueue.$CatQueue(Data$dList$dTypes.Nil, Data$dList$dTypes.Nil)), $2._2._2._2)
                )
              );
            }
            $runtime.fail();
          })()
        );
      }
      if (v.tag === "ApplyState") {
        const v1 = TcgCalculator$dCodec.appState._1(v._1);
        if (v1.tag === "Left") {
          const $1 = monadEffectHalogenM.liftEffect(Effect$dConsole.error("Failed to decode AppState JSON: " + Codec$dJSON$dDecodeError.print(v1._1)));
          return Control$dMonad$dFree.$Free(
            $1._1,
            (() => {
              if ($1._2.tag === "CatNil") {
                return Data$dCatList.$CatList("CatCons", () => action$lazy()($Action("RestoreState", v._2)), Data$dCatQueue.$CatQueue(Data$dList$dTypes.Nil, Data$dList$dTypes.Nil));
              }
              if ($1._2.tag === "CatCons") {
                return Data$dCatList.$CatList(
                  "CatCons",
                  $1._2._1,
                  Data$dCatQueue.$CatQueue(
                    $1._2._2._1,
                    Data$dList$dTypes.$List(
                      "Cons",
                      Data$dCatList.$CatList("CatCons", () => action$lazy()($Action("RestoreState", v._2)), Data$dCatQueue.$CatQueue(Data$dList$dTypes.Nil, Data$dList$dTypes.Nil)),
                      $1._2._2._2
                    )
                  )
                );
              }
              $runtime.fail();
            })()
          );
        }
        if (v1.tag === "Right") {
          const $1 = v1._1.deck;
          const $2 = v1._1.condition;
          const ids = Data$dFunctor.arrayMap(v2 => v2.id)($2);
          return Control$dMonad$dFree.$Free(
            $$get._1,
            Data$dCatList.$CatList(
              "CatCons",
              v2 => {
                const $3 = Control$dMonad$dFree.$FreeView(
                  "Bind",
                  Halogen$dQuery$dHalogenM.$HalogenF("State", s => Data$dTuple.$Tuple(undefined, {...s, deck: $1, conditions: ids})),
                  x => Control$dMonad$dFree.$Free(Control$dMonad$dFree.$FreeView("Return", x), Data$dCatList.CatNil)
                );
                if (
                  !(
                    Data$dEq.eqArrayImpl(ra => rb => ra.count === rb.count && ra.id === rb.id && ra.name === rb.name)($1.cards)(v2.deck.cards) && $1.hand === v2.deck.hand && $1.others === v2.deck.others
                  ) || !Data$dEq.eqArrayImpl(Data$dUUID.eqUUID.eq)(ids)(v2.conditions)
                ) {
                  return Control$dMonad$dFree.$Free(
                    $3,
                    Data$dCatList.$CatList(
                      "CatCons",
                      () => {
                        const $4 = for_($2)(v3 => tell1(Type$dProxy.Proxy)(v3.id)(App$dCondition.UpdateState({conditions: v3.conditions, disabled: v3.disabled})));
                        return Control$dMonad$dFree.$Free(
                          $4._1,
                          (() => {
                            if ($4._2.tag === "CatNil") {
                              return Data$dCatList.$CatList(
                                "CatCons",
                                () => tell2(Type$dProxy.Proxy)()(App$dResult.Calculate($1)(TcgCalculator$dTypes.toConditionSet($2))),
                                Data$dCatQueue.$CatQueue(Data$dList$dTypes.Nil, Data$dList$dTypes.Nil)
                              );
                            }
                            if ($4._2.tag === "CatCons") {
                              return Data$dCatList.$CatList(
                                "CatCons",
                                $4._2._1,
                                Data$dCatQueue.$CatQueue(
                                  $4._2._2._1,
                                  Data$dList$dTypes.$List(
                                    "Cons",
                                    Data$dCatList.$CatList(
                                      "CatCons",
                                      () => tell2(Type$dProxy.Proxy)()(App$dResult.Calculate($1)(TcgCalculator$dTypes.toConditionSet($2))),
                                      Data$dCatQueue.$CatQueue(Data$dList$dTypes.Nil, Data$dList$dTypes.Nil)
                                    ),
                                    $4._2._2._2
                                  )
                                )
                              );
                            }
                            $runtime.fail();
                          })()
                        );
                      },
                      Data$dCatQueue.$CatQueue(Data$dList$dTypes.Nil, Data$dList$dTypes.Nil)
                    )
                  );
                }
                return Control$dMonad$dFree.$Free(
                  Control$dMonad$dFree.$FreeView("Return", undefined),
                  Data$dCatList.$CatList(
                    "CatCons",
                    () => {
                      const $4 = for_($2)(v3 => tell1(Type$dProxy.Proxy)(v3.id)(App$dCondition.UpdateState({conditions: v3.conditions, disabled: v3.disabled})));
                      return Control$dMonad$dFree.$Free(
                        $4._1,
                        (() => {
                          if ($4._2.tag === "CatNil") {
                            return Data$dCatList.$CatList(
                              "CatCons",
                              () => tell2(Type$dProxy.Proxy)()(App$dResult.Calculate($1)(TcgCalculator$dTypes.toConditionSet($2))),
                              Data$dCatQueue.$CatQueue(Data$dList$dTypes.Nil, Data$dList$dTypes.Nil)
                            );
                          }
                          if ($4._2.tag === "CatCons") {
                            return Data$dCatList.$CatList(
                              "CatCons",
                              $4._2._1,
                              Data$dCatQueue.$CatQueue(
                                $4._2._2._1,
                                Data$dList$dTypes.$List(
                                  "Cons",
                                  Data$dCatList.$CatList(
                                    "CatCons",
                                    () => tell2(Type$dProxy.Proxy)()(App$dResult.Calculate($1)(TcgCalculator$dTypes.toConditionSet($2))),
                                    Data$dCatQueue.$CatQueue(Data$dList$dTypes.Nil, Data$dList$dTypes.Nil)
                                  ),
                                  $4._2._2._2
                                )
                              )
                            );
                          }
                          $runtime.fail();
                        })()
                      );
                    },
                    Data$dCatQueue.$CatQueue(Data$dList$dTypes.Nil, Data$dList$dTypes.Nil)
                  )
                );
              },
              Data$dCatQueue.$CatQueue(Data$dList$dTypes.Nil, Data$dList$dTypes.Nil)
            )
          );
        }
        $runtime.fail();
      }
      if (v.tag === "SaveState") {
        return Control$dMonad$dFree.$Free(
          $$get._1,
          Data$dCatList.$CatList(
            "CatCons",
            v1 => {
              const $1 = v1.deck;
              const $2 = v1.conditions;
              const $3 = requestAll(Type$dProxy.Proxy)(App$dCondition.GetState);
              const $4 = conditions => monadEffectHalogenM.liftEffect(v1.pushState({
                deck: $1,
                condition: Data$dArray.mapMaybe(id => {
                  const $4 = lookup(id)(conditions);
                  if ($4.tag === "Just") { return Data$dMaybe.$Maybe("Just", {...$4._1, id}); }
                  return Data$dMaybe.Nothing;
                })($2)
              }));
              return Control$dMonad$dFree.$Free(
                $3._1,
                (() => {
                  if ($3._2.tag === "CatNil") { return Data$dCatList.$CatList("CatCons", $4, Data$dCatQueue.$CatQueue(Data$dList$dTypes.Nil, Data$dList$dTypes.Nil)); }
                  if ($3._2.tag === "CatCons") {
                    return Data$dCatList.$CatList(
                      "CatCons",
                      $3._2._1,
                      Data$dCatQueue.$CatQueue(
                        $3._2._2._1,
                        Data$dList$dTypes.$List("Cons", Data$dCatList.$CatList("CatCons", $4, Data$dCatQueue.$CatQueue(Data$dList$dTypes.Nil, Data$dList$dTypes.Nil)), $3._2._2._2)
                      )
                    );
                  }
                  $runtime.fail();
                })()
              );
            },
            Data$dCatQueue.$CatQueue(Data$dList$dTypes.Nil, Data$dList$dTypes.Nil)
          )
        );
      }
      $runtime.fail();
    };
  });
  const action = action$lazy();
  return {
    initialState: v => ({deck: {cards: [], others: 0, hand: 0}, conditions: [], pushState: mempty, replaceState: mempty}),
    render: v => Halogen$dVDom$dTypes.$VDom(
      "Elem",
      Data$dMaybe.Nothing,
      "div",
      [Halogen$dHTML$dProperties.class_("relative overflow-x-clip")],
      [
        Halogen$dVDom$dTypes.$VDom(
          "Elem",
          Data$dMaybe.Nothing,
          "header",
          [Halogen$dHTML$dProperties.class_("flex items-baseline px-2")],
          [
            Halogen$dVDom$dTypes.$VDom(
              "Elem",
              Data$dMaybe.Nothing,
              "h1",
              [Halogen$dHTML$dProperties.class_("p-1 text-lg")],
              [Halogen$dVDom$dTypes.$VDom("Elem", Data$dMaybe.Nothing, "a", [Halogen$dHTML$dProperties.href("#")], [Halogen$dVDom$dTypes.$VDom("Text", "Draw Calculator")])]
            ),
            Halogen$dVDom$dTypes.$VDom("Text", "-"),
            Halogen$dVDom$dTypes.$VDom("Elem", Data$dMaybe.Nothing, "h2", [Halogen$dHTML$dProperties.class_("p-1")], [Halogen$dVDom$dTypes.$VDom("Text", "TCG 用ドロー確率計算機")])
          ]
        ),
        Halogen$dVDom$dTypes.$VDom(
          "Elem",
          Data$dMaybe.Nothing,
          "main",
          [Halogen$dHTML$dProperties.class_("relative mb-[80vh] flex max-w-4xl flex-col gap-3 p-1")],
          [
            Halogen$dVDom$dTypes.$VDom(
              "Elem",
              Data$dMaybe.Nothing,
              "div",
              [Halogen$dHTML$dProperties.class_("flex flex-wrap gap-1")],
              [
                Halogen$dVDom$dTypes.$VDom(
                  "Elem",
                  Data$dMaybe.Nothing,
                  "div",
                  [Halogen$dHTML$dProperties.class_("grow")],
                  [slot1(Type$dProxy.Proxy)()(App$dDeck.component)(v.deck)(UpdateDeck)]
                ),
                Halogen$dVDom$dTypes.$VDom(
                  "Elem",
                  Data$dMaybe.Nothing,
                  "div",
                  [Halogen$dHTML$dProperties.class_("flex grow basis-0 items-center justify-end rounded border-2 border-cyan-400 p-1")],
                  [Halogen$dHTML.slot_()(resultIsSymbol)(Data$dOrd.ordUnit)(Type$dProxy.Proxy)()(App$dResult.component)()]
                )
              ]
            ),
            Halogen$dVDom$dTypes.$VDom(
              "Elem",
              Data$dMaybe.Nothing,
              "ul",
              [Halogen$dHTML$dProperties.class_("flex flex-col gap-1")],
              Data$dFunctor.arrayMap((() => {
                const $0 = {...v.deck, cards: Data$dArray.filterImpl(x => x.name !== "", v.deck.cards)};
                return id => Halogen$dVDom$dTypes.$VDom(
                  "Elem",
                  Data$dMaybe.Nothing,
                  "li",
                  [Halogen$dHTML$dProperties.class_("flex items-start gap-1")],
                  [
                    Halogen$dVDom$dTypes.$VDom(
                      "Elem",
                      Data$dMaybe.Nothing,
                      "div",
                      [Halogen$dHTML$dProperties.class_("flex flex-col")],
                      [
                        Util$dHalogen.button(Halogen$dVDom$dTypes.$VDom("Elem", Data$dMaybe.Nothing, "i", [Halogen$dHTML$dProperties.class_("fa-solid fa-angle-up")], []))("text-gray-500 hover:bg-gray-200")($Action(
                          "SwapPrev",
                          id
                        )),
                        Util$dHalogen.button(Halogen$dVDom$dTypes.$VDom("Elem", Data$dMaybe.Nothing, "i", [Halogen$dHTML$dProperties.class_("fa-solid fa-xmark")], []))("text-gray-500 hover:bg-gray-200")($Action(
                          "RemoveCondition",
                          id
                        )),
                        Util$dHalogen.button(Halogen$dVDom$dTypes.$VDom("Elem", Data$dMaybe.Nothing, "i", [Halogen$dHTML$dProperties.class_("fa-solid fa-arrows-rotate")], []))("text-gray-500 hover:bg-gray-200")($Action(
                          "ToggleDisabled",
                          id
                        )),
                        Util$dHalogen.button(Halogen$dVDom$dTypes.$VDom("Elem", Data$dMaybe.Nothing, "i", [Halogen$dHTML$dProperties.class_("fa-solid fa-angle-down")], []))("text-gray-500 hover:bg-gray-200")($Action(
                          "SwapNext",
                          id
                        ))
                      ]
                    ),
                    slot2(Type$dProxy.Proxy)(id)(App$dCondition.component)($0)(ReceiveConditionUpdated(id))
                  ]
                );
              })())(v.conditions)
            ),
            Halogen$dVDom$dTypes.$VDom(
              "Elem",
              Data$dMaybe.Nothing,
              "div",
              [],
              [
                Util$dHalogen.button(Halogen$dVDom$dTypes.$VDom("Elem", Data$dMaybe.Nothing, "i", [Halogen$dHTML$dProperties.class_("fa-solid fa-plus")], []))("border border-sky-500 text-sky-700 hover:bg-sky-200")(AddCondition)
              ]
            )
          ]
        ),
        Halogen$dVDom$dTypes.$VDom(
          "Elem",
          Data$dMaybe.Nothing,
          "footer",
          [Halogen$dHTML$dProperties.class_("flex items-baseline px-2")],
          [
            Halogen$dVDom$dTypes.$VDom(
              "Elem",
              Data$dMaybe.Nothing,
              "a",
              [
                Halogen$dHTML$dProperties.class_("m-1 rounded border border-sky-500 px-2 py-1 text-sm"),
                Halogen$dHTML$dProperties.href("https://github.com/acple/tcg-calculator"),
                Halogen$dHTML$dProperties.target("_blank"),
                Halogen$dHTML$dProperties.rel("noopener noreferrer")
              ],
              [Halogen$dVDom$dTypes.$VDom("Text", "→ 使い方とかソース")]
            )
          ]
        )
      ]
    ),
    eval: Halogen$dComponent.mkEval({...Halogen$dComponent.defaultEval, handleAction: action, initialize: Data$dMaybe.$Maybe("Just", Initialize)})
  };
})();
export {
  $Action,
  AddCondition,
  ApplyState,
  Initialize,
  PrepareDefaultState,
  ReceiveConditionUpdated,
  RemoveCondition,
  RestoreState,
  SaveState,
  SwapNext,
  SwapPrev,
  ToggleDisabled,
  UpdateDeck,
  component,
  conditionIsSymbol,
  foldMap,
  for_,
  generateId,
  $$get as get,
  lookup,
  mempty,
  monadEffectHalogenM,
  requestAll,
  resultIsSymbol,
  slot1,
  slot2,
  tell1,
  tell2
};
